import { Container, createRoot } from "react-dom/client";
import  {Roteador}  from "./core/services/router";
import { Provider } from "react-redux";
import store from "./core/store/index"
import "./index.css";

const container = document.getElementById("app") as Container;
const root = createRoot(container)
root.render(
    <Provider store={store}>
        <Roteador />
    </Provider>
);